import { Content } from "@/ui";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { getRoute } from "@/functions/getRoute";
import * as additionalComponents from "./__components";
import { getRelatedJobs } from "@/functions/getRelatedJobs";

export default function FrequentlyAskedQuestionsPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const parent = simple_pages_helper.find(url_slug);
  const jobs = getRelatedJobs({ page: parent });

  return {
    props: {
      meta: {},
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              {
                label: parent.title,
                href: getRoute("dynamic", { url_slugs: ["find-a-job", parent.url_slug] }),
              },
              {
                label: "Frequently Asked Question",
                href: getRoute("dynamic", { url_slugs: ["find-a-job", parent.url_slug, "frequently-asked-questions"] }),
              },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: {
              path: `page.${parent.url_slug}.faqs.component.Header.title`,
              placeholder: `${parent.title} FAQs`,
            },
            description: {
              path: `page.${parent.url_slug}.faqs.component.Header.description`,
              placeholder: ``,
            },
            img: {
              path: `page.${parent.url_slug}.faqs.component.Header.img`,
            },
            back: {
              path: `page.${parent.url_slug}.component.Header.back`,
              placeholder: `Back to ${parent.title}`,
              href: "#",
            },
          },
        },
        {
          component: "FrequentlyAskedQuestionsFeed",
          props: {
            sector: parent.title.toLowerCase().replace("jobs", "").trim(),
          },
        },
        {
          component: "LatestJobs",
          props: {
            title: `Latest ${parent.title}`,
            items: jobs,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { url_slug: "allied-health-professional-jobs" } },
      { params: { url_slug: "doctor-jobs" } },
      { params: { url_slug: "nursing-jobs" } },
    ],
    fallback: false,
  };
}
